import React from 'react';
import { Link } from 'react-router-dom';
import './AutoProductEntries.css';

const GUIDE_URL = 'https://scribehow.com/o/_ygSvBcHTUyj_X5hGoV2bw/viewer/How_to_Configure_Auto_Product_Entries_in_CleanSweeps__SpZjwZaLS_OO-nrSBqF4CQ';

export default function AutoProductEntries() {
  return (
    <>
      <div className="setup__guide-intro">
        <h2>Display entry widget</h2>
        <p>For ALL products</p>
        <p>
          This widget may not work with every Shopify theme. If you have trouble,
          contact <a href="mailto:info@cleansweeps.app">info@cleansweeps.app</a> for
          support, or follow our{' '}
          <Link to="/api-documentation/guides/entry-displays">
            custom display guide in the API documentation
          </Link>.
        </p>
        <a href={GUIDE_URL} target="_blank" rel="noopener noreferrer">
          Open step-by-step guide in Scribe
        </a>
      </div>
      <iframe
        src={GUIDE_URL}
        height="640"
        title="How to configure Auto Product Entries in CleanSweeps"
        allowFullScreen
      />
    </>
  );
}
